module.exports = __webpack_public_path__ + "static/media/icon-save.b19bd4aa.svg";